import { useMediaSize } from '@hooks/useMediaSize'
import { useMemo } from 'react'

const EXTRA_CONTENT_CARD_DIMENSIONS_MODAL = {
  xs: { width: '100%', height: 190, icon: 32 },
  sm: { width: 232, height: 210, icon: '100%' },
  md: { width: 324, height: 172, icon: 64 },
  lg: { width: 438, height: 190, icon: 80 },
  xxl: { width: 438, height: 190, icon: 80 },
}

/** Medidas do `ExtraContentCard` dentro do `ExtraContentAllModal`. */
export function useExtraContentModalCard() {
  const size = useMediaSize()

  return useMemo(() => {
    const dimensions = EXTRA_CONTENT_CARD_DIMENSIONS_MODAL[size]
    return {
      widthValue: dimensions.width,
      minHeight: dimensions.height,
      flexDirection: (size === 'sm' ? 'column' : 'row') as 'column' | 'row',
      iconHeight: size === 'sm' ? 48 : 146,
      iconWidth: dimensions.icon,
    }
  }, [size])
}
